var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 17.7631V16.0964C18.3333 14.5432 17.271 13.2381 15.8333 12.8681M12.9166 3.00536C14.1382 3.49985 15 4.69749 15 6.09639C15 7.4953 14.1382 8.69294 12.9166 9.18743M14.1666 17.7631C14.1666 16.2099 14.1666 15.4334 13.9129 14.8208C13.5746 14.004 12.9257 13.3551 12.1089 13.0168C11.4963 12.7631 10.7198 12.7631 9.16663 12.7631H6.66663C5.11349 12.7631 4.33692 12.7631 3.72435 13.0168C2.90759 13.3551 2.25867 14.004 1.92036 14.8208C1.66663 15.4334 1.66663 16.2099 1.66663 17.7631M11.25 6.09639C11.25 7.93734 9.75758 9.42973 7.91663 9.42973C6.07568 9.42973 4.58329 7.93734 4.58329 6.09639C4.58329 4.25545 6.07568 2.76306 7.91663 2.76306C9.75758 2.76306 11.25 4.25545 11.25 6.09639Z",
    stroke: "#667185",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.d8418eaaa8570a4d48192f0390f25ac9.svg";
export { ForwardRef as ReactComponent };